import { cn } from '@/lib/utils';

/* ---------------------------------------------------------------------------
   הלוגו: פלס עם בועה במרכז — "הכל מאוזן ובשליטה". קובצי המקור ב-assets/brand.
   הצבעים מה-tokens (--color-brand-ink / --color-brand-bubble), כך שבמצב כהה
   הנייבי הופך ללבן בלי גרסה נפרדת. בגודל קטן (מתחת ל-20px) בלי קווי הסימון.
   --------------------------------------------------------------------------- */

export function LogoMark({ className, simple = false }: { className?: string; simple?: boolean }) {
  return (
    <svg viewBox="0 0 80 40" className={cn('h-6 w-auto shrink-0', className)} aria-hidden>
      <rect
        x="3"
        y="3"
        width="74"
        height="34"
        rx="17"
        fill="none"
        stroke="var(--color-brand-ink)"
        strokeWidth={simple ? 7 : 5.5}
      />
      {simple ? null : (
        <path d="M25 11 V29 M55 11 V29" stroke="var(--color-brand-ink)" strokeWidth="3" strokeLinecap="round" />
      )}
      <circle cx="40" cy="20" r={simple ? 9 : 8} fill="var(--color-brand-bubble)" />
    </svg>
  );
}

/** הסמל והשם בשורה. השם ב-Heebo (הפונט של האפליקציה), תמיד משמאל לימין. */
export function Logo({ className, size = 'md' }: { className?: string; size?: 'sm' | 'md' | 'lg' }) {
  const text = { sm: 'text-sm', md: 'text-base', lg: 'text-2xl' }[size];
  const mark = { sm: 'h-4', md: 'h-5', lg: 'h-8' }[size];
  return (
    <span dir="ltr" className={cn('inline-flex items-center gap-2', className)}>
      <LogoMark className={mark} simple={size === 'sm'} />
      <span className={cn('font-medium tracking-tight whitespace-nowrap', text)} style={{ color: 'var(--color-brand-ink)' }}>
        CraftMind<span style={{ color: 'var(--color-brand-bubble)' }}> AI</span>
      </span>
    </span>
  );
}
